import { Button, Card, Flex, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getUserMeta } from 'shared/config/store/reducers/userSlice';
import { useMessage } from 'shared/libs/hooks/useMessage/useMessage';
import classes from './PersonalInfoList.module.css';

export default function PersonalInfoList() {
  const { address } = useSelector(getUserMeta);
  const { formatMessage: t } = useIntl();
  const { showSuccess } = useMessage();

  const handleEditClick = () => {
    showSuccess(t({ id: 'profile.settings.address.notification.editAddress' }));
  };

  return (
    <Flex vertical gap={16}>
      <Flex justify='space-between' align='center'>
        <Typography.Title level={3}>{t({ id: 'inputs.address' })}</Typography.Title>
        <Button 
          variant='filled' 
          size='middle' 
          style={{ backgroundColor: '#F2F2F2', border: 0, color: '#000' }}
          onClick={handleEditClick}
        >
          {t({ id: 'buttons.edit' })}
        </Button>
      </Flex>
      <Card>
        <div className={classes.cardWrapper}>
          <Flex vertical>
            <span className={classes.itemTitle}>{t({ id: 'inputs.country' })}</span>
            <span className={classes.itemText}>{address.country}</span>
          </Flex>
          <Flex vertical>
            <span className={classes.itemTitle}>{t({ id: 'inputs.city' })}</span>
            <span className={classes.itemText}>{address.city}</span>
          </Flex>
          <Flex vertical>
            <span className={classes.itemTitle}>{t({ id: 'inputs.address' })}</span>
            <span className={classes.itemText}>{address.line1}</span>
          </Flex>
          <Flex vertical>
            <span className={classes.itemTitle}>{t({ id: 'inputs.postalCode' })}</span>
            <span className={classes.itemText}>{address.postalCode}</span>
          </Flex>
        </div>
      </Card>
    </Flex>
  );
}
